<template>
	<div class="call">
		<div class="call-con">
			<div class="call-top">Call remark<a @click="cancel" /></div>
			<div class="call-cons">
				<div class="call-opt" :class="{'call-opt1': isActive == item}" v-for="(item, index) in remarkEnumsList" :key="index" v-text="item" @click="chooseResult(item)" />
			</div>
			<textarea v-model.trim="remarkInfo.remark" placeholder="enter calling remark" />
			<div class="call-bot">
				<a @click="cancel">Cancel</a>
				<a @click="done">Done</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {

	data() {
		return {
			isActive:-1,
			remarkInfo:{
				remark:"",
				remarkType:""
			},
			remarkEnumsList:[]
		}
	},
	mounted: function() {
		this.getRemarkEnums()
	},
	methods: {
		cancel(){
			this.$emit("cancel")
		},
		
		done(){
			this.$emit("done",this.remarkInfo)
		},
		
		//获取拨打情况
		getRemarkEnums(){
		    var self = this;
		    self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/order/remarkEnums', {}, function(res){
				self.UTILS.loadGif.hide();
		        if(res.code == '0000'){
		            self.remarkEnumsList = res.data;
		        }else{
		            self.UTILS.logStr(res.message);
		        }
		    });
		},
		
		//选择外呼结果
		chooseResult(item){
			let self = this;
			this.isActive = item;
			this.remarkInfo.remarkType = item;
		},
	}
}
</script>

<style scoped>
.call{ width: 100%; height: 100%; background: rgba(0,0,0,0.3); position: fixed; top: 0; left: 0; z-index: 19;}
.call-con{ width: 6.74rem; padding-bottom: 0.4rem; background-color: #FFF; border-radius: 0.1rem; position: fixed; left: 50%; top: 50%; margin: -5.6rem 0 0 -3.37rem; overflow: hidden;}
.call-top{ height: 0.8rem; padding: 0 0.3rem; line-height: 0.8rem; text-align: left; font-size: 0.36rem; color: #FFF; background-color: #21D1CC;}
.call-top a{ width: 0.4rem; height: 0.4rem; background: url(../img/icon11.png) no-repeat center; background-size: cover; float: right; margin-top: 0.2rem;}
.call-cons{ padding: 0.2rem;max-height:6.6rem;overflow-y: auto;}
.call-con textarea{ width: 5.8rem; height: 1.5rem; padding: 0.1rem; line-height: 0.36rem; font-size: 0.28rem; color: #000; border: 0.02rem solid #787676; border-radius: 0.1rem; resize: none; display: block; margin: 0.24rem auto 0 auto;}
.call-opt{padding-left: 0.4rem; line-height: 0.4rem; font-size: 0.28rem; color: #333; background: url('../img/icon15.png') no-repeat left top; background-size: 0.32rem; margin-top: 0.13rem;}
.call-opt1{ background: url('../img/icon16.png') no-repeat left top; background-size: 0.32rem;}
.call-bot{height: 0.7rem; text-align: center; margin-top: 0.3rem;}
.call-bot a{ width: 2rem; height: 0.7rem; line-height: 0.7rem; font-size: 0.32rem; color: #FFF; background-color: #2196F3; border-radius: 0.1rem; display: inline-block; margin: 0 0.3rem;}
.call-bot a + a{ background-color: #21D1CC;}
</style>